import React, { Component } from 'react';
import { Icon, Table, Tooltip, Tabs, Button, Input, message, Popconfirm } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import Cooperation from '../UpdateJinshiCooperation';
import SetDirector from './SetDirector';
import PreviewModal from './PreviewModal';
import StartUpCharts from './StartUpCharts';
import ExportModal from './ExportModal';
import SideNav from '../SideNav';
import Filter from './Filter';
import UpdateHospital from './UpdateHospital';
import ConfigSupervisor from './ConfigSupervisor';
import CRCpeople from './CRCpeople';
import PendingCooperationModal from './PendingCooperationModal';
import { connect } from 'react-redux';
import { saveParams } from '../../../actions/noticeActions';

const { TabPane } = Tabs;

/**
 * 办事流程返回时恢复搜索条件的sessionStorage备份key
 */
const SEARCH_BACKUP_KEY = 'hospitalInfoSearchBackup';

const getSearchBackup = () => {
    try {
        return JSON.parse(sessionStorage.getItem(SEARCH_BACKUP_KEY) || '{}') || {};
    } catch (e) {
        return {};
    }
}

class HospitalInfo extends Component {
    state = {
        arry: [],
        sortParams: {},
        //优先取跳转办事流程前的搜索条件备份（返回时恢复），否则为空
        searchParams: getSearchBackup(),
        data: [],
        pagination: {
            pageSize: 10,
            current: 1,
        },
        loading: false,
        clearArry: false,
        selectedRowKeys: [],
        crcFlag: false,
        // 待合作医院
        activeTab: 'cooperate',
        pendingSearchParams: {},
        pendingData: [],
        pendingPagination: {
            pageSize: 10,
            current: 1,
        },
        pendingLoading: false,
    }

    componentDidMount() {
        const { params, menuAuth } = this.props;
        //从办事流程返回：state.searchParams已在初始化时恢复备份，这里只做备份清理；否则沿用redux params
        const hasSearchBackup = !!sessionStorage.getItem(SEARCH_BACKUP_KEY);
        sessionStorage.removeItem(SEARCH_BACKUP_KEY);
        this.setState({
            searchParams: hasSearchBackup ? this.state.searchParams : { ...params },
            areaChargeUser: !!menuAuth.areaChargeUser,
        }, () => {
            this.loadData();
            this.judgeCrcHospotial();
        });
    }

    componentWillUnmount() {
        this.props.saveParams({
            directorUserId: undefined,
            directorUserName: undefined,
        });
    }

    loadData = () => {
        const { pagination, sortParams, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        let obj = {};
        (searchParams.courtyardArea || []).map((item, index) => {
            obj[`ids[${index}]`] = item
        });
        const options = {
            method: 'POST',
            url: API_URL.hospital.hospitallist,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
                ...obj,
            },
            dataType: 'json',
            doneResult: res => {
                if (!res.error) {
                    const { arry, clearArry } = this.state;
                    const { datas = [] } = res;
                    pagination.total = res.totalCount;
                    datas.forEach((item, index) => item.index = (current - 1) * pageSize + index + 1);
                    let newArry;
                    const newSelectedRowKeys = [];
                    if (clearArry) {
                        newArry = arry.filter(item => datas.some(innerItem => innerItem.hospitalId == item));
                    } else {
                        newArry = arry;
                    }
                    newArry.forEach(item => {
                        const selectData = datas.find(innerItem => innerItem.hospitalId == item);
                        if (selectData) {
                            newSelectedRowKeys.push(selectData.index);
                        }
                    });
                    this.setState({
                        pagination,
                        data: datas,
                        arry: newArry,
                        loading: false,
                        selectedRowKeys: newSelectedRowKeys,
                    });
                }
            },
        };
        $.sendRequest(options);
    }

    judgeCrcHospotial = () => {
        const options = {
            method: 'POST',
            url: API_URL.hospital.judgeCrcHospotial,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({ crcFlag: res.crcFlag });
            },
        };
        $.sendRequest(options);
    }

    search = params => {
        const { pagination } = this.state;
        const searchParams = { ...params };
        this.setState({
            searchParams,
            pagination: { ...pagination, current: 1 },
            clearArry: true,
        }, () => {
            this.loadData();
        });
    }

    export = (searchParams) => {
        this.exportModalRef.show(searchParams);
    }

    /**
     * 判断当前是否为历史固化数据查询
     */
    isHistoricalData = () => {
        const { date } = this.state.searchParams;
        if (date) {
            const now = new Date();
            const curYearMonth = now.getFullYear() * 100 + (now.getMonth() + 1);
            const dateYearMonth = parseInt(date.replace('-', ''));
            return dateYearMonth < curYearMonth;
        }
        return false;
    }

    getColumns = () => {
        const { crcFlag } = this.state;
        const columns = [];
        columns.push({
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 60,
        }, {
            title: '医院官方名称',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            fixed: 'left',
            width: 180,
            sorter: true,
            sortType: 'common',
        }, {
            title: '医院曾用名称',
            dataIndex: 'generalNames',
            key: 'generalNames',
            width: 140,
        }, {
            title: '院区',
            dataIndex: 'courtyardArea',
            key: 'courtyardArea',
            width: 100,
        }, {
            title: '等级',
            dataIndex: 'hospitalLevel',
            key: 'hospitalLevel',
            sorter: true,
            sortType: 'common',
            width: 80,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 80,
        }, {
            title: '省',
            dataIndex: 'hospitalProvince',
            key: 'hospitalProvince',
            sorter: true,
            sortType: 'common',
            width: 80,
        }, {
            title: '市',
            dataIndex: 'hospitalCity',
            key: 'hospitalCity',
            sorter: true,
            sortType: 'common',
            width: 80,
        }, {
            title: '县级行政区（如无则默认为上级行政单位）',
            dataIndex: 'hospitalCounty',
            key: 'hospitalCounty',
            width: 80,
        }, {
            title: '详细地址',
            dataIndex: 'hospitalAddress',
            key: 'hospitalAddress',
            width: 140,
        }, {
            title: '邮编',
            dataIndex: 'postCode',
            key: 'postCode',
            width: 80,
        }, {
            title: '有无中心药房',
            dataIndex: 'centerPharmacy',
            key: 'centerPharmacy',
            width: 80,
            render: text => String(text) === 'true' ? '有' : (String(text) === 'false' ? '无' : '')
        })
        if (!crcFlag) {
            columns.push({
                title: '与津石合作程度',
                dataIndex: 'cooperationDegreeShow',
                key: 'cooperationDegreeShow',
                width: 100,
            }, {
                title: '不合作原因分类',
                dataIndex: 'rejectReasonShow',
                key: 'rejectReasonShow',
                width: 100,
            }, {
                title: '不合作原因说明',
                dataIndex: 'cooperationRejectReason',
                key: 'cooperationRejectReason',
                width: 120,
            }, {
                title: '合作程度备注',
                dataIndex: 'cooperationDegreeComments',
                key: 'cooperationDegreeComments',
                width: 120,
            }, {
                title: '不合作科室',
                dataIndex: 'nonCooperativeDepartments',
                key: 'nonCooperativeDepartments',
                width: 120,
            }, {
                title: '备注',
                dataIndex: 'remark',
                key: 'remark',
                width: 120,
            }, {
                title: '参与的项目数量',
                children: [{
                    title: '所有项目',
                    dataIndex: 'inveSiteNum',
                    key: 'inveSiteNum',
                    sortType: 'common',
                    width: 100,
                }, {
                    title: '进行中项目',
                    dataIndex: 'underwayInveSiteNum',
                    key: 'underwayInveSiteNum',
                    sortType: 'common',
                    width: 100,
                }],
            }, {
                title: '筛选病例数',
                children: [{
                    title: '所有项目',
                    dataIndex: 'filterAccount',
                    key: 'filterAccount',
                    sortType: 'common',
                    width: 100,
                }, {
                    title: '进行中项目',
                    dataIndex: 'underwayFilterAccount',
                    key: 'underwayFilterAccount',
                    sortType: 'common',
                    width: 100,
                }],
            }, {
                title: '随机病例数',
                children: [{
                    title: '所有项目',
                    dataIndex: 'randomAccount',
                    key: 'randomAccount',
                    sortType: 'common',
                    width: 100,
                }, {
                    title: '进行中项目',
                    dataIndex: 'underwayRandomAccount',
                    key: 'underwayRandomAccount',
                    sortType: 'common',
                    width: 100,
                }],
            }, {
                title: '最大启动时长(天)',
                dataIndex: 'maxBeginDay',
                key: 'maxBeginDay',
                sorter: true,
                sortType: 'common',
                width: 140,
            }, {
                title: '平均启动时长(天)',
                dataIndex: 'avgBeginDay',
                key: 'avgBeginDay',
                sorter: true,
                sortType: 'common',
                width: 140,
                render: (text, record) => <a onClick={() => this.showStartUpCharts(record.hospitalId)}>{text}</a>,
            }, {
                title: '最小启动时长(天)',
                dataIndex: 'minBeginDay',
                key: 'minBeginDay',
                sorter: true,
                sortType: 'common',
                width: 140,
            })
        }

        columns.push({
            title: '医院主管姓名',
            dataIndex: 'directorUserCompellation',
            key: 'directorUserCompellation',
            width: 100,
            render: (text, record) => {
                return record.directorUserWorkStatus == 'LEFT' ? <span style={{ color: '#999999' }}>{text}</span> : text;
            },
        }, {
            title: '医院主管工号',
            dataIndex: 'directorEmployeeCode',
            key: 'directorEmployeeCode',
            width: 100,
            render: (text, record) => {
                return record.directorUserWorkStatus == 'LEFT' ? <span style={{ color: '#999999' }}>{text}</span> : text;
            },
        }, {
            title: '医院主管手机号',
            dataIndex: 'directorUserMobile',
            key: 'directorUserMobile',
            width: 120,
            render: (text, record) => {
                return record.directorUserWorkStatus == 'LEFT' ? <span style={{ color: '#999999' }}>{text}</span> : text;
            },
        }, {
            title: '医院主管邮箱',
            dataIndex: 'directorUserEmail',
            key: 'directorUserEmail',
            width: 120,
            render: (text, record) => {
                return record.directorUserWorkStatus == 'LEFT' ? <span style={{ color: '#999999' }}>{text}</span> : text;
            },
        })
        if (!crcFlag) {
            columns.push({
                title: (
                    <span>
                        现任CRC人数
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'取职位是"临床协调员"的现任CRC'}>
                            <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'hospitalCrcCount',
                key: 'hospitalCrcCount',
                width: 80,
                render: (text, record) => {
                    return <a onClick={() => this.showCRCpeople(record)}>{text}</a>
                }
            }, {
                title: (
                    <span>
                        临床试验操作经验平均值（月）
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'CRC临床试验经验年限合计/CRC人数'}>
                            <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'avgWorkLife',
                key: 'avgWorkLife',
                width: 100,
            }, {
                title: '与津石是否有合作',
                dataIndex: 'userCooperation',
                key: 'userCooperation',
                width: 80,
                render: (text, record) => {
                    const { systemCooperation } = record;
                    if (systemCooperation == 1) { return '是'; }
                    return text == 1 ? '是' : '否';
                },
            })
        }
        // 历史固化数据不显示操作栏
        if (!this.isHistoricalData()) {
        columns.push({
            title: '操作',
            dataIndex: 'option',
            key: 'option',
            fixed: 'right',
            width: 140,
            render: (text, record) => {
                const { canSetJsChargeUser, systemCooperation, canSetCooperation, directorUserId, jsChargeUserId,
                    cooperationDegreeType, areaChargeUserId } = record;
                const { userId } = sessionStorage;
                const { crcFlag } = this.state;
                return (
                    <span>
                        {!crcFlag && <a onClick={() => this.showPreviewModal(record)}>项目明细</a>}
                        {!crcFlag && <span className="ant-divider" />}
                        {cooperationDegreeType != 'NOT_UNDERTAKE' && <span><a onClick={() => this.showWorkFlow(record)}>办事流程</a></span>}
                        {(directorUserId == userId || jsChargeUserId == userId || areaChargeUserId == userId) &&
                            <span>
                                <span className="ant-divider" />
                                <a onClick={() => this.showUpdateHospital(record)}>修改</a>
                            </span>
                        }
                        {(canSetCooperation === 1 && systemCooperation == 0) &&
                            <span>
                                <span className="ant-divider" />
                                <a onClick={() => this.showCooperation(record)}>修改津石合作情况</a>
                            </span>
                        }
                        {(areaChargeUserId == userId) &&
                            <span>
                                <span className="ant-divider" />
                                <a onClick={() => this.showConfigSupervisor(record)}>配置医院主管</a>
                            </span>
                        }
                    </span>
                );
            },
        })
        } // end !isHistoricalData
        return columns
    }

    getDataSource = () => {
        const { data } = this.state;
        return (data || []).map(item => ({ ...item }));
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({ pagination, sortParams, clearArry: false }, () => {
            this.loadData();
        });
    }

    showStartUpCharts = hospitalId => {
        this.startUpChartsRef.show(hospitalId);
    }

    showPreviewModal = record => {
        this.previewModalRef.show(record);
    }

    showCreateModal = id => {
        this.createModalRef.show(id);
    }

    setDirector = record => {
        this.setDirectorRef.show(record);
    }

    showWorkFlow = record => {
        const { hospitalId, hospitalName } = record;
        //备份搜索条件，返回合作医院列表时恢复
        sessionStorage.setItem(SEARCH_BACKUP_KEY, JSON.stringify(this.state.searchParams || {}));
        sessionStorage.hospitalId = hospitalId;
        sessionStorage.hospitalName = hospitalName;
        window.location.href = './#/hospital/workFlow';
    }

    showCooperation = record => {
        this.cooperationRef.show(record);
    }

    showUpdateHospital = record => {
        this.updateHospitalRef.show(record);
    }

    showConfigSupervisor = record => {
        this.configSupervisorRef.show(record);
    }

    showCRCpeople = record => {
        this.CRCpeopleRef.show(record);
    }

    onSelectChange = (record, selected) => {
        const { selectedRowKeys, arry } = this.state;
        if (selected) {
            const isExist = selectedRowKeys.some(item => item == record.index);
            !isExist && selectedRowKeys.push(record.index);
            const isIdExist = arry.some(item => item == record.hospitalId);
            !isIdExist && arry.push(record.hospitalId);
        } else {
            let idx;
            selectedRowKeys.forEach((item, index) => { if (record.index == item) { idx = index; } });
            (idx || (!idx && idx === 0)) && selectedRowKeys.splice(idx, 1);
            let idIdx;
            arry.forEach((item, index) => { if (record.hospitalId == item) { idIdx = index; } });
            (idIdx || (!idIdx && idIdx === 0)) && arry.splice(idIdx, 1);
        }
        this.setState({ arry, selectedRowKeys });
    }

    onSelectAllChange = (selected, selectedRows, changeRows) => {
        const { arry, selectedRowKeys } = this.state;
        if (selected) {
            changeRows.forEach(item => {
                let idx;
                selectedRowKeys.forEach((selectItem, index) => { if (selectItem == item.index) { idx = index; } });
                !(idx || (!idx && idx === 0)) && selectedRowKeys.push(item.index);
                let idIdx;
                arry.forEach((arryItem, index) => { if (arryItem == item.hospitalId) { idIdx = index; } });
                !(idIdx || (!idIdx && idIdx === 0)) && arry.push(item.hospitalId);
            });
        } else {
            changeRows.forEach(item => {
                let idx;
                selectedRowKeys.forEach((selectItem, index) => { if (selectItem == item.index) { idx = index; } });
                (idx || (!idx && idx === 0)) && selectedRowKeys.splice(idx, 1);
                let idIdx;
                arry.forEach((arryItem, index) => { if (arryItem == item.hospitalId) { idIdx = index; } });
                (idIdx || (!idIdx && idIdx === 0)) && arry.splice(idIdx, 1);
            });
        }
        this.setState({ arry, selectedRowKeys });
    }

    // ======================== 待合作医院 ========================

    onTabChange = (key) => {
        this.setState({ activeTab: key });
        if (key === 'pending') {
            this.loadPendingData();
        }
    }

    loadPendingData = () => {
        const { pendingPagination, pendingSearchParams } = this.state;
        const { current, pageSize } = pendingPagination;
        this.setState({ pendingLoading: true });
        $.sendRequest({
            method: 'POST',
            url: API_URL.hospital.pendingCooperationList,
            data: {
                offset: current,
                limit: pageSize,
                ...pendingSearchParams,
            },
            dataType: 'json',
            doneResult: res => {
                if (!res.error) {
                    const datas = res.datas || [];
                    pendingPagination.total = res.totalCount || datas.length;
                    datas.forEach((item, index) => item.index = (current - 1) * pageSize + index + 1);
                    this.setState({
                        pendingPagination,
                        pendingData: datas,
                        pendingLoading: false,
                    });
                } else {
                    this.setState({ pendingLoading: false });
                }
            },
            failResult: () => {
                this.setState({ pendingLoading: false });
            }
        });
    }

    handlePendingSearchChange = (e) => {
        this.pendingSearchValue = e.target.value;
    }

    handlePendingSearch = () => {
        const { pendingPagination } = this.state;
        this.setState({
            pendingSearchParams: { hospitalName: this.pendingSearchValue || '' },
            pendingPagination: { ...pendingPagination, current: 1 },
        }, () => {
            this.loadPendingData();
        });
    }

    handlePendingKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.handlePendingSearch();
        }
    }

    showPendingAdd = () => {
        this.pendingModalRef.show();
    }

    showPendingEdit = (record) => {
        this.pendingModalRef.show(record);
    }

    handlePendingDelete = (record) => {
        $.sendRequest({
            method: 'POST',
            url: API_URL.hospital.pendingCooperationDelete,
            data: { hospitalPendingCooperationId: record.hospitalPendingCooperationId },
            dataType: 'json',
            doneResult: res => {
                message.success('删除成功');
                this.loadPendingData();
            },
        });
    }

    handlePendingToCooperation = (record) => {
        $.sendRequest({
            method: 'POST',
            url: API_URL.hospital.pendingCooperationToCooperate,
            data: { hospitalPendingCooperationId: record.hospitalPendingCooperationId },
            dataType: 'json',
            doneResult: res => {
                message.success('转换成功');
                this.loadPendingData();
            },
        });
    }

    handlePendingTableChange = (pagination) => {
        this.setState({ pendingPagination: pagination }, () => {
            this.loadPendingData();
        });
    }

    getPendingColumns = () => {
        const { areaChargeUser } = this.state;
        const positionRole = sessionStorage.positionRole;
        const hasPendingPermission = positionRole === 'CRCC' || positionRole === 'CRCM' || positionRole === 'PML' || areaChargeUser || sessionStorage.isClinicalBO === 'true';

        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 60,
        }, {
            title: '医院官方名称',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            width: 200,
        }, {
            title: '医院曾用名称',
            dataIndex: 'generalNames',
            key: 'generalNames',
            width: 180,
        }, {
            title: '院区',
            dataIndex: 'courtyardArea',
            key: 'courtyardArea',
            width: 100,
        }, {
            title: '医院等级',
            dataIndex: 'hospitalLevel',
            key: 'hospitalLevel',
            width: 100,
        }, {
            title: '省市县级行政区',
            dataIndex: 'regionShow',
            key: 'regionShow',
            width: 200,
            render: (text, record) => {
                const parts = [record.hospitalProvince, record.hospitalCity, record.hospitalCounty].filter(Boolean);
                return parts.join('/') || '-';
            }
        }, {
            title: '详细地址',
            dataIndex: 'hospitalAddress',
            key: 'hospitalAddress',
            width: 200,
        }, {
            title: '邮编',
            dataIndex: 'postCode',
            key: 'postCode',
            width: 100,
        }];

        if (hasPendingPermission) {
            columns.push({
                title: '操作',
                dataIndex: 'option',
                key: 'option',
                width: 240,
                render: (text, record) => (
                    <span>
                        <a onClick={() => this.showPendingEdit(record)}>修改</a>
                        <span className="ant-divider" />
                        <Popconfirm title="确定删除该待合作医院？" onConfirm={() => this.handlePendingDelete(record)} okText="确定" cancelText="取消">
                            <a>删除</a>
                        </Popconfirm>
                        <span className="ant-divider" />
                        <Popconfirm title="确定将该待合作医院转为合作医院？" onConfirm={() => this.handlePendingToCooperation(record)} okText="确定" cancelText="取消">
                            <a>转入合作医院</a>
                        </Popconfirm>
                    </span>
                ),
            });
        }

        return columns;
    }

    render() {
        const { loading, pagination, searchParams, selectedRowKeys, arry, crcFlag, activeTab,
            pendingData, pendingPagination, pendingLoading, areaChargeUser } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onSelect: this.onSelectChange,
            onSelectAll: this.onSelectAllChange,
        };
        return (
            <div className="content">
                <SideNav selectKey="detail" />
                <div className="main">
                    <Tabs activeKey={activeTab} onChange={this.onTabChange} type="card">
                        <TabPane tab="合作医院" key="cooperate">
                            <Filter
                                showCreateModal={this.showCreateModal}
                                search={this.search}
                                export={this.export}
                                params={searchParams}
                                crcFlag={crcFlag}
                            />
                            <Table
                                rowSelection={rowSelection}
                                columns={this.getColumns()}
                                dataSource={this.getDataSource()}
                                rowKey={record => record.index}
                                loading={loading}
                                scroll={{ x: crcFlag ? 1000 : 2640, y: 460 }}
                                onChange={this.handleTableChange}
                                pagination={pagination}
                                className="hospitalTableStyle"
                            />
                        </TabPane>
                        <TabPane tab="待合作医院" key="pending">
                            <div style={{ marginBottom: 16 }}>
                                <div className="search-bar" style={{ marginBottom: 8 }}>
                                    <div className="search-item">
                                        <label className="ui-label">医院官方名称</label>
                                        <Input
                                            style={{ width: 200 }}
                                            placeholder="请输入"
                                            onChange={this.handlePendingSearchChange}
                                            onKeyDown={this.handlePendingKeyDown}
                                        />
                                    </div>
                                    <div className="search-item">
                                        <Button type="primary" onClick={this.handlePendingSearch}>搜索</Button>
                                        {(sessionStorage.positionRole === 'CRCC' || sessionStorage.positionRole === 'CRCM' || areaChargeUser || sessionStorage.positionRole === 'PML' || sessionStorage.isClinicalBO === 'true') &&
                                            <Button type="primary" style={{ marginLeft: 8 }}
                                                onClick={this.showPendingAdd}>新增</Button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <Table
                                columns={this.getPendingColumns()}
                                dataSource={(pendingData || []).map(item => ({ ...item }))}
                                rowKey={record => record.index || record.hospitalPendingCooperationId}
                                loading={pendingLoading}
                                scroll={{ x: 1300, y: 460 }}
                                onChange={this.handlePendingTableChange}
                                pagination={pendingPagination}
                                className="hospitalTableStyle"
                            />
                        </TabPane>
                    </Tabs>
                </div>
                <SetDirector ref={el => this.setDirectorRef = el} loadData={this.loadData} />
                <StartUpCharts ref={el => this.startUpChartsRef = el} searchParams={searchParams} />
                <ExportModal ref={el => this.exportModalRef = el} arry={arry} />
                <PreviewModal ref={el => this.previewModalRef = el} params={searchParams} />
                <Cooperation ref={el => this.cooperationRef = el} type="HOSPITAL" loadData={this.loadData} />
                <UpdateHospital ref={el => this.updateHospitalRef = el} loadData={this.loadData} />
                <ConfigSupervisor ref={el => this.configSupervisorRef = el} loadData={this.loadData} />
                <CRCpeople ref={el => this.CRCpeopleRef = el} loadData={this.loadData} />
                <PendingCooperationModal ref={el => this.pendingModalRef = el} loadData={this.loadPendingData} />
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return { params: state.noticeState.params, menuAuth: state.menuState.menuAuth || {} };
}

const mapDispatchToProps = (dispatch) => {
    return { saveParams: (params) => dispatch(saveParams(params)) };
}

export default connect(mapStateToProps, mapDispatchToProps)(HospitalInfo);



// WEBPACK FOOTER //
// ./src/components/hospital/hospitalInfo/index.js